import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ticketApi } from './api';
import type { Ticket, TicketStatus } from './api';
import StatusBadge from './StatusBadge';
import SlaPill from './SlaPill';

const STATUSES: Array<TicketStatus | ''> = ['', 'OPEN', 'ACKNOWLEDGED', 'IN_PROGRESS', 'RESOLVED', 'CLOSED', 'CANCELLED'];

export default function TrackTickets() {
  const [tickets, setTickets] = useState<Ticket[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [filters, setFilters] = useState({ status: '', q: '', raisedBy: '' });

  async function loadTickets() {
    setLoading(true);
    setError(null);
    try {
      setTickets(await ticketApi.listTickets(filters));
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Unable to load tickets');
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    loadTickets();
  }, [filters.status]);

  return (
    <div className="ticket-card">
      <h2>Track tickets</h2>
      <div className="ticket-filters">
        <input
          placeholder="Search subject or reference..."
          value={filters.q}
          onChange={(event) => setFilters({ ...filters, q: event.target.value })}
          onKeyDown={(event) => event.key === 'Enter' && loadTickets()}
        />
        <input
          placeholder="Filter by your email"
          value={filters.raisedBy}
          onChange={(event) => setFilters({ ...filters, raisedBy: event.target.value })}
          onKeyDown={(event) => event.key === 'Enter' && loadTickets()}
        />
        <select value={filters.status} onChange={(event) => setFilters({ ...filters, status: event.target.value })}>
          {STATUSES.map((status) => <option key={status || 'all'} value={status}>{status ? status.replace('_', ' ') : 'All statuses'}</option>)}
        </select>
        <button onClick={loadTickets}>Search</button>
      </div>

      {error && <div className="ticket-alert error">{error}</div>}
      {loading ? <p className="ticket-muted">Loading...</p> : (
        <div className="ticket-table-wrap">
          <table className="ticket-table">
            <thead>
              <tr>
                <th>Reference</th><th>Subject</th><th>Category</th><th>Status</th><th>SLA</th><th>Raised</th>
              </tr>
            </thead>
            <tbody>
              {tickets.length === 0 && <tr><td colSpan={6} className="ticket-muted center">No tickets found.</td></tr>}
              {tickets.map((ticket) => (
                <tr key={ticket.id}>
                  <td><Link to={`/tickets/view/${ticket.id}`}>{ticket.reference}</Link></td>
                  <td>{ticket.subject}</td>
                  <td>{ticket.category}</td>
                  <td><StatusBadge status={ticket.status} /></td>
                  <td><SlaPill sla={ticket.sla} /></td>
                  <td className="ticket-muted">{new Date(ticket.createdAt).toLocaleDateString()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
